import {
  Stack, Chip, ChipProps, Typography, 
  Tooltip, TooltipProps, tooltipClasses, Alert
} from "@mui/material"
import { styled } from '@mui/material/styles'

import { ArticlesAuthorResult } from "interface/article"

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))

type AuthorChipProps = {
  author: ArticlesAuthorResult
  targetSisetuCode?: string
  targetKojinCode?: string
  targetAuthorId?: number
} & ChipProps
export const AuthorChip = ({
  author,
  targetSisetuCode,
  targetKojinCode,
  targetAuthorId,
  ...other
}: AuthorChipProps) => {
  const emphasis = (
    targetSisetuCode ? author.sisetuList?.some(authorsSisetu => authorsSisetu.sisetuCode === targetKojinCode) : 
    targetKojinCode ? author.kojinCode === targetKojinCode : 
    targetAuthorId ? author.authorId === targetAuthorId :
    false
  )
  const variant = emphasis ? 'filled' : 'outlined'
  const color = emphasis ? 'primary' : 'default'
  return author.kojinCode ? (
    <HtmlTooltip
      title={
        author.sisetuList && author.sisetuList.length > 0 ? (
          <Stack direction='column' spacing={1} padding={1}>
            { author.sisetuList.map((authorsSisetu, i) => {
              return <Typography key={`author-sisetu-${i}-${authorsSisetu.sisetuCode}`} variant='body2' component='div'>{authorsSisetu.sisetuName}</Typography>
            }) }
          </Stack>
        ) : (
          <Alert severity="info">所属なし</Alert>
        )
      }
    >
      <Chip
        variant={variant}
        label={author.authorName}
        size='small'
        color={color}
        sx={{ cursor: 'pointer' }}
        {...other}
      />
    </HtmlTooltip>
  ) : (
    <Chip
      variant={variant}
      color={color}
      label={author.authorName + '?'}
      size='small'
      {...other}
    />
  )
}
